import { Seller, SellerGroup } from '../../customer/types/customer.types';
import { OfflineDatabaseSeller } from '../database/offlineDatabase/types/offlineDatabaseSeller.types';

export class OfflineDatabaseSellerTransformer {
  static toOnlineSeller(seller: OfflineDatabaseSeller): Seller {
    return {
      phone: '',
      userId: '',
      surname: '',
      id: seller.id,
      role: 'VENDEDOR',
      name: seller.name,
      position: 'SELLER',
      email: seller.email,
      roleName: 'VENDEDOR',
      contextId: seller.id,
      lastAccess: new Date(),
      licenseType: 'TECEO_MARCA',
      sellerGroup: {} as SellerGroup,
    };
  }
}
